/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1TexttypesQueryResponse } from '../../types/GetV1Texttypes.ts'

export const getV1TexttypesQueryKey = () => [{ url: '/v1/TextTypes' }] as const

export type GetV1TexttypesQueryKey = ReturnType<typeof getV1TexttypesQueryKey>

/**
 * {@link /v1/TextTypes}
 */
export async function getV1Texttypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1TexttypesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/TextTypes`,
        ...requestConfig,
    })
    return res
}

export function getV1TexttypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1TexttypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1TexttypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1TexttypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Texttypes(config)
        },
    })
}

/**
 * {@link /v1/TextTypes}
 */
export function useGetV1Texttypes<
    TData = ResponseConfig<GetV1TexttypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1TexttypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1TexttypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1TexttypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1TexttypesQueryKey()

    const query = useQuery(
        {
            ...getV1TexttypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
